import {useEffect, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomCheckbox from '@s-ui/react-atom-checkbox'
import {useDelayToNextFrame} from '@adv-mt/mt-hook-use-delay-to-next-frame'
import CheckboxUnchecked from '@adv-mt/mt-svg-icons/lib/CheckboxEmpty.js'
import CheckboxChecked from '@adv-mt/mt-svg-icons/lib/CheckboxFilled.js'

import {BASE_CLASS} from '../../../config.js'

const FilterBasicLegacyMultiSelectionItem = ({
  extendedInfo,
  icon: Icon,
  id,
  isDisabled = false,
  isHighlighted = false,
  isSelected: isSelectedFromProps,
  label,
  onChange
}) => {
  const [isSelected, setIsSelected] = useState(isSelectedFromProps)

  const delayToNextFrame = useDelayToNextFrame()

  const hasIcon = Boolean(Icon)
  const hasExtendedInfo = Boolean(extendedInfo)

  const filterBasicLegacyMultiSelectionLabelClassName = cx(`${BASE_CLASS}-multiSelectionItemLabel`, {
    [`${BASE_CLASS}-multiSelectionItemLabel--bold`]: isSelected || isHighlighted
  })

  const filterBasicLegacyMultiSelectionLabelWrapperClassName = cx(`${BASE_CLASS}-multiSelectionItemLabelWrapper`, {
    [`${BASE_CLASS}-multiSelectionItemLabelWrapper--spaced`]: hasIcon && !hasExtendedInfo
  })

  const handleClick = e => {
    // Needed to prevent unexpected behavior with AtomCheckbox
    e.stopPropagation()
    e.preventDefault()

    setIsSelected(!isSelected)

    delayToNextFrame(() => {
      onChange({id, label})
    })
  }

  useEffect(() => {
    isSelectedFromProps !== isSelected && setIsSelected(isSelectedFromProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedFromProps])

  return (
    <div className={`${BASE_CLASS}-multiSelectionItem`}>
      <div className={`${BASE_CLASS}-multiSelectionItemIconLabel`} onClick={handleClick}>
        {hasIcon && (
          <div className={`${BASE_CLASS}-multiSelectionItemIconWrapper`}>
            <Icon />
          </div>
        )}
        <div className={filterBasicLegacyMultiSelectionLabelWrapperClassName}>
          <p className={filterBasicLegacyMultiSelectionLabelClassName}>{label}</p>
          {hasExtendedInfo && <p className={`${BASE_CLASS}-multiSelectionItemExtendedInfo`}>{extendedInfo}</p>}
        </div>
      </div>
      <AtomCheckbox
        checked={isSelected}
        checkedIcon={CheckboxChecked}
        uncheckedIcon={CheckboxUnchecked}
        disabled={isDisabled}
        id={id}
        onChange={handleClick}
      />
    </div>
  )
}

FilterBasicLegacyMultiSelectionItem.displayName = 'FilterBasicLegacyMultiSelectionItem'
FilterBasicLegacyMultiSelectionItem.propTypes = {
  extendedInfo: PropTypes.string,
  icon: PropTypes.func,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default FilterBasicLegacyMultiSelectionItem
